export default __webpack_public_path__ + "static/randomquotes-a02f42e86412343937d0d8803c0c7b8a.png";